/**
 * 来自小程序的页面访问
 * 1、分享页面的访问：h5.fangcloud.com/wx/xxx 或 h5.fangcloud.com/h5/wx/xxx
 * 2、主页的访问：h5.fangcloud.com?scenario=wx_applet&wx_applet_token=[] 或 h5.fangcloud.com/h5?scenario=wx_applet&wx_applet_token=[]
 */
import {
  getQueryStringValue
} from '../utils/common'
import config from '../config'
import wxajax from '../utils/wxajax'
import {
  WX_LOGIN
} from '../config/applet-api'
import { FREQUENT_SPACE_INFO, GET_BASE_INFO } from '../config/api'
import {
  setLanguageType
} from '@/utils/i18n'
import H5Scenario from './h5Scenario'
import load from '@/utils/fangcloud-loader'
import Cookies from 'js-cookie'

export default class WxAppletBoot {
  constructor () {
    // 如果跳转到其他页面后重新加载页面，那么通过初始页面的url带过来的信息会丢失，因此需要备份到Cookies中
    let scenario = getQueryStringValue(H5Scenario.SCENARIO)
    if (scenario && scenario !== null && scenario !== '') {
      Cookies.set(H5Scenario.SCENARIO, scenario)
    }
    if (!scenario || scenario === null || scenario === '') {
      scenario = Cookies.get(H5Scenario.SCENARIO)
    }
    this.scenario = scenario

    let token = getQueryStringValue(H5Scenario.WX_APPLET_TOKEN)
    if (token && token !== null && token !== '') {
      Cookies.set(H5Scenario.WX_APPLET_TOKEN, token)
    }
    // 如果取不到token 则说明用户使用的是旧版本（V1.0.1以及之前版本）的小程序
    // 或者用户不是从小程序进入的
    if (!token || token === null || token === '') {
      token = getQueryStringValue(H5Scenario.COMPATIBLE_TOKEN)
    }
    if (!token || token === null || token === '') {
      token = Cookies.get(H5Scenario.WX_APPLET_TOKEN)
    }

    this.token = token

    this.isToShare = false
  }

  isFromWx () {
    let pathNameArr = location.pathname.split('/').filter(item => item)
    // h5.fangcloud.com/wx/xxx h5.fangcloud.com/h5/wx/xxx
    this.isToShare = pathNameArr[0] === 'wx' || pathNameArr[1] === 'wx'
    // 旧版本（V1.0.1以及之前版本）的小程序没有scenario字段
    // 如果是旧版本小程序进入的H5，则需要我们手动给scenario赋值
    // 同时旧版本不需要将字段缓存到Cookie中，因此略去这个功能
    if (this.isToShare) {
      this.scenario = H5Scenario.WX_APPLET
    }
    return this.isToShare || this.scenario === H5Scenario.WX_APPLET
  }

  loadJs () {
    load.js('//res.wx.qq.com/open/js/jweixin-1.4.0.js').then(_ => {})
  }

  customStyle () {
    this._addRules([
      '.nav-bar-bgcolor { background-color: #fff; color: #000; border-bottom: 1px solid #e3e3e7; }',
      '.title-bar.nav-bar-bgcolor { border-bottom: none }',
      '.file-header .van-nav-bar__text, .van-nav-bar__title, .file-header .msg-icon-box, .file-select .title-bar, .search-main .search-header .van-field input { color: #000; }',
      '.search-main .search-header .van-field { background-color: #f6f7f9; }',
      '.search-main .search-header .van-field .van-icon { color: #b2b7ca }',
      '.search-main .search-header .van-field input::-webkit-input-placeholder { color: #c1c1c1; }',
      '.preview-header-bgcolor { background-color: #4b545c; }'
    ])
  }

  // 这个方法可以抽取为一个公共方法
  _addRules (rules) {
    var style = document.createElement('style')
    // WebKit hack :(
    style.appendChild(document.createTextNode(''))
    document.head.appendChild(style)
    const sheet = style.sheet

    rules.forEach((rule, i) => {
      sheet.insertRule(rule, i)
    })
  }

  bootApplet () {
    config.h5_scenario = this.scenario
    config.auth_token = this.token
    return new Promise(resolve => {
      // get account info and csrf_token
      // 第一次只能发起一个请求 要不然 csrf_token 会有问题
      wxajax({
        url: WX_LOGIN
      }).then(res => {
        return wxajax({
          url: GET_BASE_INFO,
          accept_all_errors: true
        })
      }).then(result => {
        const {
          enterprise_info: {
            is_from_wechat_enterprise
          } = {},
          user_guide_settings: {
            user_guide_h5_sync,
            user_guide_h5_upload,
            user_guide_h5_logout
          } = {},
          is_h5_show_user_guide = false
        } = result
        config.csrf_token = result.csrf_token
        config.user_info = result.user_info
        config.enterprise_info = result.enterprise_info
        config.unread_messages_count = result.unread_messages_count
        config.product_name = result.product_name
        config.is_from_wechat_enterprise = is_from_wechat_enterprise // 记录是否来自于企业微信
        config.enterpirse_wxwork_guide_sync = is_from_wechat_enterprise && !user_guide_h5_sync // 企业微信引导下载客户端
        config.enterpirse_wxwork_guide_upload = is_from_wechat_enterprise && !user_guide_h5_upload // 企业微信引导上传文件
        config.enterpirse_wxwork_guide_logout = is_from_wechat_enterprise && !user_guide_h5_logout // 微信引导登出，然后用其他账号登录
        config.enterpirse_is_h5_show_user_guide = is_h5_show_user_guide // 企业微信引导下载客户端 后端开关 控制开启与关闭
        // set language type
        setLanguageType(result.enterprise_info ? result.enterprise_info.language_type : 'enterprise')

        // if (result.custom_color) {
        //   customStyle(result.custom_color)
        // }

        document.title = config.product_name || ''

        if (result.base_url) {
          config.imageUrl = result.base_url.replace(/\/$/, '')
          config.loginUrl = config.imageUrl + '/sso/login'
          config.logoutUrl = config.imageUrl + '/sso/logout'
          config.registerUrl = config.imageUrl + '/auth/register'
        }

        if (this.isToShare) {
          resolve()
        } else {
          return wxajax({
            url: FREQUENT_SPACE_INFO,
            accept_all_errors: false
          }).then(result => {
            config.frequent_space = result
            resolve()
          })
        }
      }).catch(e => {
        console.log(e)
      })
    })
  }
}
